export const Strings_FR = {
  thwaitesglacier: 'Glacier Thwaites',
  antarctica: 'Antarctique',
  southpole: 'Pôle Sud',
  southamerica: 'FR_Südamerika',
  weddelsea: 'Mer de Weddell',
  rossea: 'Mer de Ross',
  belowsealevel:
    "Une grande partie de la masse terrestre de l'Antarctique occidental se trouve sous le niveau de la mer.",
  titleB: "Profil d'altitude de l'Antarctique",
}
